import { useEffect } from "react";
import { scrollToElementWithRetry } from "@jti/ui";
const stringParamName = "scrollTo";
const ScrollToElement = () => {
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        if (params.has(stringParamName)) {
            scrollToElementWithRetry(params.get(stringParamName) || "");
        }
    }, []);
    return null;
};
export default ScrollToElement;
//# sourceMappingURL=ScrollToElement.js.map